import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { AuthService } from 'src/app/service/auth.service';
import { ReportApiService } from 'src/app/shared/services/customer-api/report-api.service';
import * as moment from 'moment';

export enum ReportType {
  CreditWatch = 'credit_watch',
  Esg = 'esg',
  EsgRisk = 'esg_risk',
  ImmediateRisk = 'immediate_risk',
  GeneralRisk = 'general_risk',
  EbSim = 'eb_sim',
  EbSimRisk = 'eb_sim_risk',
  Investment = 'investment',
  DueDiligenceTabular = 'due_diligence_tabular',
  DueDiligenceTabularPortfolio = 'due_diligence_tabular_portfolio',
}

export interface ReportDialogData {
  reportType: ReportType;
  titleLine1: string;
  titleLine2: string;
  status: string;
  entityId?: string;
  portfolioName?: string;
  portfolioContent?: string[];
  messageLine?: string;
  searchQuery?: string;
  queryName?: string;
}

@Component({
  selector: 'app-dialog-report',
  templateUrl: './dialog-report.component.html',
  styleUrls: ['./dialog-report.component.scss'],
})
export class DialogReportComponent implements OnInit {
  reportStatus: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ReportDialogData,
    private dialogRef: MatDialogRef<DialogReportComponent>,
    public auth: AuthService,
    private reportApi: ReportApiService,
    public snackBar: MatSnackBar,
  ) {}

  ngOnInit() {
    this.reportStatus = this.data.status;
  }

  // send email with report
  onClick() {
    const date = moment(new Date()).format('YYYY-MM-DD');
    const type = this.data.reportType;
    if (this.data.searchQuery) {
      this.reportApi
        .sendQueryReport(this.data.searchQuery, this.data.queryName, type, date)
        .subscribe(
          () => {
            this.dialogRef.close();
            this.snackBar.open(
              'Thank you for your interest. In the next minutes, you will receive an email with a download link to access the report.',
              'OK',
              { duration: 5000 },
            );
          },
          () => {
            this.dialogRef.close();
            this.snackBar.open(
              'Something went wrong, report could not be sent.',
              'OK',
              { duration: 5000 },
            );
          },
        );
    } else if (this.data.portfolioName != null) {
      this.reportApi
        .sendReportPortfolio(
          this.data.portfolioName,
          this.data.portfolioContent,
          type,
          date,
        )
        .subscribe(
          () => {
            this.dialogRef.close();
            this.snackBar.open(
              'Thank you for your interest. In the next minutes, you will receive an email with a download link to access the report.',
              'OK',
              { duration: 5000 },
            );
          },
          () => {
            this.dialogRef.close();
            this.snackBar.open(
              'Something went wrong, report could not be sent.',
              'OK',
              { duration: 5000 },
            );
          },
        );
    } else {
      this.reportApi.sendReport(this.data.entityId, type, date).subscribe(
        () => {
          this.dialogRef.close();
          this.snackBar.open(
            'Thank you for your interest. In the next minutes, you will receive an email with a download link to access the report.',
            'OK',
            { duration: 5000 },
          );
        },
        () => {
          this.dialogRef.close();
          this.snackBar.open(
            'Something went wrong, report could not be sent.',
            'OK',
            { duration: 5000 },
          );
        },
      );
    }
  }
}
